module.exports = __webpack_public_path__ + "static/media/favicon.0d30a058.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dublin-express/favicon.ico
// module id = 706
// module chunks = 0